export const environment = {
  production: false,
  environmentName: 'staging',
  appVersion: '0.0.0-staging',
  suppressLocalSentry: true,
  sentryDsn:
    'https://8b205ac9f964d6e03e7bfbea28134a10@o4510041001885701.ingest.us.sentry.io/4510754351874048',
  port: 10000,
  domain: 'https://edmsapi.gxstaging.net/api',
  dwtProductKey:
    't0199EQYAACFvGM+G92Vx+DCjsMvhh5dPrLmmV2bD/X/qvmW+/Y+KpJC/YwWxq1wQQHKyX9hrIfreFJGZ8wk4fAD7K2mE6gi0152TBzilv1OovxMDnPzISeTCq42nrcK8YwLvwBwAOa/DCSAH4loKYJm+o3eGBOAWIA1AWmtAC6juwhef8+Idn9ea/negNScPcEp/Zx6QPk4McPIjpw+ItqQ2v9s1BgT5zUkAbgFSBfD7kV0CQiXALUCqwFKkmBOALBvnrDYfWiM/Mg==',
};
